export class ProductDetailFile {

  file_type: string | undefined = undefined;
  file: string = '';
  file_name: string = '';

  constructor(initialValues: Partial<ProductDetailFile>) {
    Object.assign(this, initialValues);
    if (this.file){
      this.file_name = this.file.split("/")[-1];
    }
  }
}
